import { Event } from 'services/EventEmitter';
import BazaarvoiceService from './BazaarvoiceService';
import { mix } from 'core/mixwith';
import AnalyticsMixin from 'mixins/Analytics';

/**
 * This is a description of the BazaarvoiceRatingAndReviews constructor function.
 * @class
 * @classdesc BazaarvoiceService extend. It emits BazaarVoice RR specific events.
 * @extends BazaarvoiceService
 */
export default class BazaarvoiceRatingAndReviews extends mix(BazaarvoiceService).with(AnalyticsMixin) {
    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        super.bindEvents();
        Event.on('BV.submission.load', this.onSubmissionLoad.bind(this));
        Event.on('BV.submission.submitted', this.onSubmissionSubmitted.bind(this));
    }

    /**
     * Handler for submissionLoad event,
     * triggered when a consumer opens a review or Q&A submission form.
     */
    onSubmissionLoad() {
        Event.emit('analytics.event', {
            category: 'product detail page',
            action: 'write review',
            label: this.analytics.label,
            extraData: {
                event_name: 'write_review',
                product_info: this.analytics.label,
            },
        });
    }

    /**
     * Handler for submissionLoad event,
     * triggered when a consumer opens a review or Q&A submission form.
     * @param {Object} eventData - Third-party provider event data.
     */
    onSubmissionSubmitted(eventData) {
        if (eventData.contentType === 'review' || eventData.contentType === 'question' || eventData.contentType === 'answer') {
            const contentTypeMap = {
                review: {
                    emitEvent: 'BV.review.submitted',
                    action: 'submit a review',
                    eventName: 'submit_review',
                },
                question: {
                    emitEvent: 'BV.question.submitted',
                    action: 'ask a question',
                    eventName: 'ask_question',
                },
                answer: {
                    emitEvent: 'BV.answer.submitted',
                    action: 'post answer',
                    eventName: 'post_answer',
                },
            };
            const typeData = contentTypeMap[eventData.contentType];

            if (eventData.contentType === 'question') {
                Event.emit('analytics.virtualPage', {
                    virtualPageURL: `/quick-view${this.element.dataset.pathname}/questions-&-answers/ask-question`,
                    virtualPageTitle: 'questions & answers ask question',
                });
            }

            Event.emit(typeData.emitEvent);
            Event.emit('analytics.event', {
                category: 'product detail page',
                action: typeData.action,
                label: this.analytics.label,
                extraData: {
                    event_name: typeData.eventName,
                    product_info: this.analytics.label,
                },
            });
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        Event.removeListener('BV.submission.load');
        Event.removeListener('BV.submission.submitted');
    }
}
